import React from 'react'

function BlankWrapper ({ children }) {
  return (<div className="h-full">
    {children}
  </div>);
};

export default BlankWrapper;
